/**
 * @flow
 * @relayHash 2b99294f90e0a63261153d49a0018e62
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BaseSettingsTabQueryVariables = {||};
export type BaseSettingsTabQueryResponse = {|
  +settings: {|
    +adminEmails: ?$ReadOnlyArray<?string>
  |}
|};
export type BaseSettingsTabQuery = {|
  variables: BaseSettingsTabQueryVariables,
  response: BaseSettingsTabQueryResponse,
|};
*/


/*
query BaseSettingsTabQuery {
  settings {
    adminEmails
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "settings",
    "storageKey": null,
    "args": null,
    "concreteType": "Settings",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "adminEmails",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "BaseSettingsTabQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "BaseSettingsTabQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "BaseSettingsTabQuery",
    "id": null,
    "text": "query BaseSettingsTabQuery {\n  settings {\n    adminEmails\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7e87041b4e674a94977806d0ec8e7871';
module.exports = node;
